import { useState } from 'react'

import { Hidden } from '@twistopayments/design-system/components/atoms/hidden'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { ArrowIcon } from '@twistopayments/design-system/icons'

import type { SectionsGalleryComponent } from '@twisto/api-cms'
import { useIsMobile } from '@twisto/hooks'

import { useHighlightedText } from 'homepage/libs/hooks'

import { GalleryItem } from './gallery-item'
import * as styles from './gallery.styles'

const MAX_ITEMS = 6

export const Gallery = ({
  title,
  highlighted,
  description,
  items,
}: SectionsGalleryComponent) => {
  const { after, before, highlight } = useHighlightedText(title, highlighted)
  const isMobile = useIsMobile()
  const [currentPage, setCurrentPage] = useState(0)

  const totalPages = items ? Math.ceil(items.length / MAX_ITEMS) : 0

  const filteredItems = isMobile
    ? items
    : items?.slice(currentPage * MAX_ITEMS, (currentPage + 1) * MAX_ITEMS)

  const showPrevButton = currentPage > 0
  const showNextButton =
    items && items.length > MAX_ITEMS && currentPage < totalPages - 1

  return (
    <section css={styles.section}>
      <div css={styles.container}>
        <Typography css={styles.title} fontWeight="heavy" variant="h2">
          {before}
          <span css={styles.highlighted}>{highlight}</span>
          {after}
        </Typography>
        <Typography css={styles.description} variant="b1">
          {description}
        </Typography>
      </div>
      <div css={styles.items}>
        <Hidden smMdDown>
          {showPrevButton && (
            <button
              css={styles.sliderButton}
              onClick={() => setCurrentPage((prev) => prev - 1)}
            >
              <ArrowIcon />
            </button>
          )}
        </Hidden>
        {filteredItems?.map((item) => <GalleryItem key={item.id} {...item} />)}
        <Hidden smMdDown>
          {showNextButton && (
            <button
              css={[styles.sliderButton, styles.next]}
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              <ArrowIcon />
            </button>
          )}
        </Hidden>
      </div>
    </section>
  )
}
